angular.module("admin")


	.factory("AdminLogCampagnsService", ["$resource", "$http", "SharedProperties", "CONSTANTS", "ENV", function ($resource, $http, SharedProperties, CONSTANTS, ENV) {
		return {

			/**
       * Récupérer les logs des campagnes de comptages d'une application
       * @param nameAppli
       * @returns {HttpPromise}
       */
			getLogsCampagns: function (nameAppli) {
				return $http.get(ENV.API_URL + "/admin/log-campaigns/" + nameAppli);
			},

			getFile: function (applicationName, schemaName, fileName) {
				return $http.get(ENV.API_URL + "/admin/log-campaigns/file/" + applicationName + "/" + schemaName + "/" + fileName);
			},

			getApplicationsStatistiques: function () {
				return $http.get(ENV.API_URL + "/comptage/applications");
			},

			deleteFiles: function (listFiles, applicationName) {
				var fd = new FormData();
				fd.append("files", listFiles);
				fd.append("typeAppli", applicationName);
				return $http.post(ENV.API_URL + "/admin/log-campaigns/", fd, {
					transformRequest: angular.identity,
					headers: {"Content-Type": undefined}
				});
			}

		};
	}
	]);
